export const SUCCESS_TEXT = "Success";
export const DELETE_ERROR_TEXT = "Deleting error";
export const CANCEL_TEXT = "Cancel";
export const CONFIRM_TEXT = "Confirm";
